import { render, staticRenderFns } from "./AssetType.vue?vue&type=template&id=42e9e644&scoped=true"
import script from "./AssetType.vue?vue&type=script&lang=js"
export * from "./AssetType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e9e644",
  null
  
)

export default component.exports